/**
 * @prettier
 */
import { createSelector } from 'reselect';
import { mapCardTypeToBusinessUnitComponent } from '../../../components/onboard/onboardHelpers';

const getPdpState = state => state.cards.pdp;

// Card suite. Will only change when suite is fetched.
export const getActiveUUID = createSelector(getPdpState, pdpState => pdpState.activeUUID);
export const getPageData = createSelector(getPdpState, pdpState => pdpState.data || {});
export const getCardType = createSelector(getPageData, pageData => pageData.cardType);
export const getCardFamily = createSelector(getPageData, pageData => pageData.family);
export const getCardOrientation = createSelector(getPageData, pageData => pageData.orientation);
export const getIsStampFoilCard = createSelector(getPageData, pageData => pageData.isStampFoilCard);
export const getImages = createSelector(getPdpState, pdpState => pdpState.images);
export const getIsBusy = createSelector(getPdpState, pdpState => pdpState.busy);
export const getIsCustomFoilAvailable = createSelector(
  getPdpState,
  pdpState => pdpState.data && pdpState.data.isCustomFoilAvailable
);
export const getBusinessUnitComponent = createSelector(getCardType, cardType =>
  mapCardTypeToBusinessUnitComponent(cardType)
);

// Current selection. Will change whenever selected options change.
export const getActiveMedium = createSelector(getPdpState, pdpState => pdpState.activeMedium);
export const getActiveMediumKey = createSelector(getPdpState, pdpState => pdpState.activeMediumKey);
export const getActiveMediumData = createSelector(getPdpState, pdpState => pdpState.activeMediumData);
export const getActiveSelection = createSelector(getPdpState, pdpState => pdpState.activeMediumSelection);
export const getActiveVariationUUID = createSelector(
  getPdpState,
  pdpState => pdpState.activeVariation && pdpState.activeVariation.uuid
);
export const getAvailableOptions = createSelector(
  getActiveMediumData,
  activeMediumData => activeMediumData.available_options
);
export const getIsMagnet = createSelector(getActiveMediumKey, activeMediumKey => activeMediumKey === 'magnet');
export const getQuantity = createSelector(getPdpState, pdpState => pdpState.quantity);
export const getCostData = createSelector(getPdpState, pdpState => pdpState.cost);



// WEBPACK FOOTER //
// ./src/cards/reducers/pdp/selectors.js